<style lang="less" scoped></style>

<template>
  <div class="user-mg">
    <Row>
      <Col span="8">
        <Input v-model="query" search placeholder="请输入搜索内容" @on-search="handleSearch"/>
      </Col>
      <Col span="16" style="text-align: right;">
        <Button code="cscp.user.import" type="primary" ghost icon="ios-cloud-upload-outline" style="margin-right: 10px;" @click="importShow = true">导入</Button>
        <Button code="cscp.user.add" type="primary" icon="md-add" @click="handleCreateOrEditItem">新建</Button>
      </Col>
    </Row>
    <Row style="margin-top: 8px;">
      <Table :columns="columns" :data="data" :loading="isDisabled"></Table>
    </Row>
    <Row style="margin-top: 8px;" type="flex" justify="end">
      <Page :total="dataTotal" :page-size="pageSize" @on-change="handlePageChange" show-elevator show-total :current="currentPageIndex"></Page>
    </Row>
    <import-user-modal v-model="importShow" @success="getUserList"></import-user-modal>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isDisabled: false,
      query: '',
      dataTotal: 0,
      currentPageIndex: 1,
      pageSize: 10,
      data: [],
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 184,
          render: (h, params) => {
            return h('span', params.index + 1);
            }
        },
        {
          key: 'username',
          title: '用户名',
          width: 184,
          align: 'center'
        },
        // {
        //   key: 'familyName',
        //   title: '姓',
        //   align: 'center'
        // },
        {
          key: 'name',
          title: '姓名',
          width: 184,
          align: 'center'
        },
        {
          key: 'mobile',
          title: '手机',
          width: 184,
          align: 'center'
        },
        {
          key: 'email',
          title: '电子邮件',
          width: 184,
          align: 'center'
        },
        // {
        //   key: 'lastLogin',
        //   title: '最后登录时间',
        //   align: 'center',
        //   render: (h, params) => {
        //         return h('span', params.row.lastLogin ? this.dayjs(params.row.lastLogin).format('YYYY-MM-DD HH:mm:ss') : '');
        //     }
        // },
        {
          key: 'discTitle',
          title: '描述标题',
          width: 184,
          align: 'center'
        },
        {
          key: 'discDetail',
          title: '个人介绍',
          width: 184,
          align: 'center'
        },
        {
          key: 'registerTime',
          title: '注册时间',
          width: 184,
          align: 'center',
          render: (h, params) => {
                return h('span', params.row.registerTime ? this.dayjs(params.row.registerTime).format('YYYY-MM-DD HH:mm:ss') : '');
            }
        },
        {
          title: '操作',
          align: 'center',
          width: 190,
          key: 'handle',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    code: 'cscp.user.edit',
                    type: 'primary',
                    size: 'small',
                    disabled: params.row.name.indexOf('管理员') > 0
                  },
                  on: {
                    click: () => {
                      this.handleCreateOrEditItem(params.row.userId)
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  style: {
                    margin: '0 5px'
                  },
                  props: {
                    code: 'cscp.user.detail',
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.jumpDetail(params.row.userId);
                    }
                  }
                },
                '查看'
              ),
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    title: '确定删除这条数据吗？',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteUser(params.row.userId)
                    }
                  }
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        code: 'cscp.user.del',
                        type: 'error',
                        placement: 'top',
                        size: 'small',
                        disabled: params.row.name.indexOf('管理员') > 0
                      }
                    },
                    '删除'
                  )
                ]
              )
            ])
          }
        }
      ],
      importShow: false
    }
  },
  components: {
    'import-user-modal': () => import('./import-user-modal.vue')
  },
  methods: {
    init () {
      this.currentPageIndex = 1
      this.getUserList()
    },
    handleSearch () {
      this.init()
    },
    getUserList () {
      let msg = this.$Message.loading({
        content: '正在更新数据',
        duration: 0
      })
      this.isDisabled = true
      const [url, httpConfig] = [
        '/api/system/cscpUserDetailsOr',
        {
          params: {
            'usernameLike': this.query,
            'familyNameLike': this.query,
            'nameLike': this.query,
            'mobileLike': this.query,
            'emailLike': this.query,
            'discTitleLike': this.query,
            'discDetailLike': this.query,
            'userType':'0',
            sort: 'user_id',
            page: this.currentPageIndex,
            size: this.pageSize
          }
        }
      ]
      this.$http.get(url, httpConfig).then(response => {
        this.data = response.data.data
        this.dataTotal = response.data.recordsTotal
        msg()
        this.isDisabled = false
      }).catch(error => {
        msg()
        this.isDisabled = false
        if (error.response) {
          this.$Message.error('数据获取失败！')
        }
      })
    },
    handleCreateOrEditItem (id) {
      if (id) {
        this.$byStoreSet('user-edit', { id })
        this.$router.push({
          name: 'user-edit'
        })
      } else {
        this.$router.push({
          name: 'user-add'
        })
      }
    },
    jumpDetail(id) {
      this.$byStoreSet('user-edit', { id });
      this.$router.push({
          name: 'user-detail'
        })
    },
    handlePageChange (index) {
      this.currentPageIndex = index
      this.getUserList()
    },
    deleteUser (id) {
      this.$http.delete(`/api/system/cscpUsers/${id}`).then(resposne => {
        this.init()
        this.$Message.success('删除成功！')
      }).catch(error => {
        if (error.response) {
          this.$Message.error('删除失败！')
        }
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
